<template>
  <div id="lom-events-list">
    <v-container class="py-0">
      <v-speed-dial
        v-model="fab"
        :top="top"
        :bottom="bottom"
        :right="right"
        :left="left"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
        :fixed="true"
        v-if="SpeedDialFlag"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <!-- <v-btn fab dark small color="green">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>-->
        <v-btn fab dark small color="indigo" @click.prevent="addRecord">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <!-- <v-btn fab dark small color="red">
          <v-icon>mdi-delete</v-icon>
        </v-btn>-->
      </v-speed-dial>
    </v-container>
    <v-dialog v-model="titlePreviewRecordPrompt" persistent max-width="75%">
      <new-lo-title-preview
        :pageTitle="titlePreviewRecordPageTitle"
        :previewFlag="titlePreviewFlag"
        :recordData="selectedData"
        @hidePreviewRecordPrompt="hideTitlePreviewRecordPrompt"
        @hideEditRecordPrompt="hideTitleEditRecordPrompt"
        v-if="titlePreviewRecordPrompt"
      ></new-lo-title-preview>
    </v-dialog>
    <!-- Premium Header Card -->
    <v-container class="px-4 py-6">
      <v-card
        elevation="24"
        class="premium-header-card mb-6 overflow-hidden"
        style="min-height: 150px"
      >
        <div class="header-gradient-bg">
          <div class="header-backdrop-effect"></div>
          <div class="header-content-premium pa-8">
            <v-row align="center">
              <v-col cols="auto">
                <div class="header-icon-box">
                  <v-icon size="48" color="white"
                    >mdi-folder-multiple-outline</v-icon
                  >
                </div>
              </v-col>
              <v-col>
                <h1 class="header-title white--text">
                  <v-progress-linear
                    v-if="LoadingFlag"
                    indeterminate
                    color="white"
                    style="max-width: 300px"
                  ></v-progress-linear>
                  <span v-else>{{ PageTitle }}</span>
                </h1>
                <p class="header-subtitle white--text">
                  {{
                    LoadingFlag ? "Loading page details..." : PageDescription
                  }}
                </p>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  @click.prevent="refreshPageData"
                  icon
                  large
                  class="premium-action-btn"
                  color="white"
                  :loading="LoadingFlag"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </v-container>
    <v-container class="py-0 px-4">
      <v-card class="main-card">
        <v-card-text class="content-section">
          <!-- Action Buttons Row -->
          <v-row wrap class="action-buttons-section">
            <v-col cols="12" class="d-flex justify-end gap-2">
              <router-link to="/new-lo/member-title-create">
                <v-btn elevation="8" class="premium-btn premium-btn-primary">
                  <v-icon left>mdi-file-document</v-icon>
                  <span class="btn-text">Apply New Title Clearance</span>
                </v-btn>
              </router-link>
              <router-link to="/new-lo/member-subscription-payment">
                <v-btn elevation="8" class="premium-btn premium-btn-success">
                  <v-icon left>mdi-credit-card-multiple</v-icon>
                  <span class="btn-text">New LO Subscription</span>
                </v-btn>
              </router-link>

            </v-col>
          </v-row>

          <br />
          <br />
          <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
            <b-spinner
              variant="primary"
              type="grow"
              label="Loading..."
            ></b-spinner>
          </div>
          <v-card class="notes-card" v-if="NotesFlag">
            <v-card-title class="notes-header">
              <v-icon color="#1976d2" class="mr-2"
                >mdi-information-outline</v-icon
              >
              Important Procedure
            </v-card-title>
            <v-card-text class="notes-list">
              <ol>
                <li>
                  <strong>Apply for Title:</strong> First apply for title name
                  using the "Apply New Title Clearance" button.
                </li>
                <li>
                  <strong>Check Status:</strong> The status of purchased LO
                  names along with their approval status can be found in the
                  table below.
                </li>
                <li>
                  <strong>Validity Period:</strong> As per constitution, a new
                  LO name purchased has a validity of 60 days before which it
                  has to be extended as a new LO else the LO name will expire.
                </li>
                <li>
                  <strong>Complete Payment:</strong> Once "Title clearance"
                  approval has been received from NHQ, proceed to pay
                  subscription for the new LO using "New LO Subscription"
                  button.
                </li>
              </ol>
            </v-card-text>
          </v-card>
          <v-container
            class="py-0"
            v-if="tableData1.length == 0 && LoadingFlag == false"
          >
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <div class="empty-state">
                  <v-icon size="64" color="#ccc" class="mb-3"
                    >mdi-inbox-outline</v-icon
                  >
                  <h3>No Records Found</h3>
                  <p>
                    There are no provisional LO titles yet. Click "Apply New
                    Title Clearance" to get started.
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <br />
          <v-container class="py-0" v-if="tableData1.length > 0">
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <div class="records-info">
                  <v-icon color="#4caf50" class="mr-2">mdi-check-circle</v-icon>
                  <span
                    ><strong>{{ tableData1.length }}</strong> record(s)
                    found</span
                  >
                </div>
              </v-col>
            </v-row>
            <v-col align="center" cols="12" md="12">
              <!-- <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search records here"
                single-line
                hide-details
              ></v-text-field>-->
              <br />
              <v-data-table
                class="elevation-1"
                loading-text="Loading... Please wait"
                v-model="selected"
                :search="search"
                :loading="TableLoadingFlag"
                :item-key="tableOptions1.ItemKey"
                :single-select="tableOptions1.SingleSelectFlag"
                :headers="tableColumns1"
                :items="tableData1"
                :items-per-page="tableOptions1.ItemsPerPage"
                :footer-props="tableOptions1.FooterProps"
                :hide-default-footer="tableOptions1.HideDefaultFooter"
              >
                <template v-slot:[`item.ActiveStatusTxt`]="{ item }">
                  <v-chip
                    :color="getActiveStatusColor(item.ActiveStatusTxt)"
                    draggable
                    dark
                    >{{ item.ActiveStatusTxt }}</v-chip
                  >
                </template>
                <template v-slot:[`item.ProfilePic`]="{ item }">
                  <img width="100" height="100" :src="item.ProfilePic" />
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom v-if="item.ReceiptPath != ''">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :href="item.ReceiptPath"
                        target="_blank"
                        class="mx-2"
                        icon
                        dark
                        small
                        color="#EDBE38"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-receipt </v-icon>
                      </v-btn>
                    </template>
                    <span> Receipt Download </span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.ApplicationPath != ''">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :href="item.ApplicationPath"
                        target="_blank"
                        class="mx-2"
                        icon
                        dark
                        small
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-file-pdf </v-icon>
                      </v-btn>
                    </template>
                    <span> Application Download </span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.PreviewFlag != ''">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="titlePreviewData(item, 1)"
                        class="mx-2"
                        icon
                        dark
                        small
                        color="blue"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-file-search </v-icon>
                      </v-btn>
                    </template>
                    <span> Preview </span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.ApprovalFlag != ''">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="titlePreviewData(item, 2)"
                        class="mx-2"
                        icon
                        dark
                        small
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-file-check </v-icon>
                      </v-btn>
                    </template>
                    <span> Approve </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-container>
          <br />
          <br />
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import NewLoTitlePreview from "@/view/pages/erp/new_lo_title/NewLoTitlePreview.vue";

export default {
  mixins: [common],
  components: {
    NewLoTitlePreview,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      SpeedDialFlag: false,
      TableLoadingFlag: false,
      NotesFlag: true,

      titlePreviewRecordPrompt: false,
      titlePreviewRecordPageTitle: "",
      titlePreviewFlag: false,
      selectedData: {},

      rows: [],

      Modules: {},

      tableData1: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      ZoneCode: "",
      LomCode: "",
      YearCode: "",
      MonthCode: "",
      MonthName: "",

      PageInfo: {},
      PageTitle: "Provisional LO Titles",
      PageDescription:
        "Manage and track new LO title applications and subscriptions",
      JciYearCode: "",
      YearName: "",
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.JciYearCode = tr.CurrentJciYearId;
        var YearName = tr.CurrentJciYearName;
        this.YearName = YearName;

        var MonthCode = this.$route.query.month;
        MonthCode = MonthCode == (null || undefined) ? 0 : MonthCode;
        console.log({ MonthCode });
        this.MonthCode = MonthCode;

        var tempDate1 = YearName + "-" + MonthCode + "-01";
        console.log({ tempDate1 });

        var tempDate2 = new Date(tempDate1);
        console.log({ tempDate2 });
        var MonthName = tempDate2.toLocaleString("en-us", { month: "long" });
        console.log({ MonthName });
        this.MonthName = MonthName;

        var ZoneCode = this.$session.get("ZoneId");
        ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
        console.log("ZoneCode=" + ZoneCode);
        this.ZoneCode = ZoneCode;

        var LomCode = this.$session.get("LomId");
        LomCode = LomCode == (null || undefined) ? "" : LomCode;
        console.log("LomCode=" + LomCode);
        this.LomCode = LomCode;

        this.searchForm();
      }
    },
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },

    refreshPageData() {
      console.log("refreshPageData called");

      this.LoadingFlag = true;

      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "provisional_lo",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    resetForm() {
      this.$refs.form2.reset();
      this.tableData1 = [];
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    hideTitleEditRecordPrompt() {
      console.log("hideTitleEditRecordPrompt called");
      this.titlePreviewRecordPrompt = false;
      this.searchForm();
    },
    hideTitlePreviewRecordPrompt() {
      console.log("hideTitlePreviewRecordPrompt called");
      this.titlePreviewRecordPrompt = false;
    },
    titlePreviewData(tr, type) {
      console.log("titlePreviewData called");
      console.log({ type });
      var OrderType = tr.OrdersType;
      console.log({ OrderType });
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var pageTitle = "";
        var previewFlag = false;
        if (type == 1) {
          previewFlag = true; //
          pageTitle =
            OrderType == 3
              ? "Preview New LO Title Details"
              : "Preview New LO Payment Details";
        } else {
          pageTitle =
            OrderType == 3
              ? "Approve New LO Title Details"
              : "Approve New LO Payment Details";
        }
        this.titlePreviewRecordPrompt = true;
        this.titlePreviewFlag = previewFlag;
        this.titlePreviewRecordPageTitle = pageTitle;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    searchForm() {
      console.log("searchForm is called");

      var message = "";

      // var validate1 = this.$refs.form2.validate();
      // console.log("validate1=" + validate1);

      var YearCode = this.JciYearCode;
      console.log({ YearCode });

      var LomCode = this.LomCode;
      console.log({ LomCode });

      if (YearCode != "" && LomCode != "") {
        this.LoadingFlag = true;
        this.tableData1 = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/new-lom/lists";
        var upload = {
          UserInterface: 4,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var table = {};
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            console.log({ records });

            if (flag == 1) {
              var options = records.TableOptions;
              console.log({ options });

              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableOptions1 = options;
              thisIns.tableData1 = records.TableData;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (LomCode == "") {
          message += "Lom should not be empty. ";
        }
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
// Premium Color Palette
$primary-navy: #001a4d;
$secondary-navy: #003d7a;
$tertiary-cyan: #0099cc;
$accent-cyan: #00bfff;

$success-color: #10b981;
$gradient-main: linear-gradient(
  135deg,
  $secondary-navy 0%,
  $tertiary-cyan 100%
);

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

#lom-events-list {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  min-height: 100vh;
  padding: 24px;
  animation: fadeIn 0.6s ease-in-out;

  // PREMIUM HEADER
  .premium-header-card {
    background: $gradient-main !important;
    border-radius: 16px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(0, 26, 77, 0.3);

    .header-gradient-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: $gradient-main;
    }

    .header-backdrop-effect {
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.1) 1px,
        transparent 1px
      );
      background-size: 50px 50px;
      animation: rotate 20s linear infinite;
    }
  }

  .header-content-premium {
    position: relative;
    z-index: 1;
  }

  .header-icon-box {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 50%;
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    animation: float 3s ease-in-out infinite;
  }

  .header-title {
    font-size: 32px;
    font-weight: 800;
    letter-spacing: 0.5px;
    margin: 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    animation: slideInLeft 0.6s ease-out 0.1s both;
  }

  .header-subtitle {
    font-size: 16px;
    opacity: 0.9;
    margin: 4px 0 0 0;
    animation: fadeInUp 0.8s ease-out 0.2s both;
  }

  .premium-action-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    background: rgba(255, 255, 255, 0.2) !important;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50% !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;

    &:hover {
      transform: translateY(-4px) scale(1.1);
      background: rgba(255, 255, 255, 0.3) !important;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3) !important;
    }

    &:active {
      transform: translateY(-2px);
    }
  }

  // MAIN CARD
  .main-card {
    border-radius: 14px !important;
    box-shadow: 0 12px 40px rgba(0, 26, 77, 0.12) !important;
    animation: fadeInUp 0.6s ease-out 0.2s both;
  }

  // ACTION BUTTONS
  .action-buttons-section {
    margin-bottom: 24px;
    animation: slideDown 0.6s ease-in-out 0.2s both;
  }

  .premium-btn {
    border-radius: 10px !important;
    font-weight: 700 !important;
    padding: 14px 28px !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    color: white !important;
    font-size: 13px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;

    .btn-text {
      margin-left: 6px;
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3) !important;
    }

    &:active {
      transform: translateY(-2px);
    }
  }

  .premium-btn-primary {
    background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%) !important;

    &:hover {
      background: linear-gradient(135deg, #1565c0 0%, #0a3d80 100%) !important;
    }
  }

  .premium-btn-success {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;

    &:hover {
      background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
    }
  }

  // CONTENT SECTION
  .content-section {
    padding: 32px !important;
  }

  // NOTES CARD
  .notes-card {
    border-left: 5px solid #1976d2 !important;
    background: linear-gradient(
      135deg,
      rgba(25, 118, 210, 0.08) 0%,
      rgba(119, 235, 255, 0.04) 100%
    ) !important;
    border-radius: 12px !important;
    box-shadow: 0 8px 24px rgba(25, 118, 210, 0.1) !important;
    animation: slideInLeft 0.6s ease-out 0.3s both;
  }

  .notes-header {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    color: #1a237e;
    margin-bottom: 16px;

    .v-icon {
      margin-right: 12px;
      font-size: 28px;
    }
  }

  .notes-list {
    margin-left: 20px;
    font-size: 14px;
    line-height: 2;
    color: #333;

    li {
      margin-bottom: 12px;
      animation: fadeInUp 0.4s ease-out both;

      &:nth-child(1) {
        animation-delay: 0.1s;
      }
      &:nth-child(2) {
        animation-delay: 0.15s;
      }
      &:nth-child(3) {
        animation-delay: 0.2s;
      }
      &:nth-child(4) {
        animation-delay: 0.25s;
      }

      strong {
        color: #1976d2;
      }
    }
  }

  // RECORDS INFO
  .records-info {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: white;
    padding: 16px 20px;
    background: linear-gradient(135deg, $success-color 0%, #059669 100%);
    border-radius: 10px;
    border-left: 5px solid #047857;
    animation: slideInLeft 0.4s ease-in-out;
    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
    font-weight: 700;
    letter-spacing: 0.3px;

    .v-icon {
      margin-right: 12px;
    }
  }

  // EMPTY STATE
  .empty-state {
    padding: 80px 20px;
    text-align: center;
    animation: fadeInUp 0.6s ease-out;

    .v-icon {
      opacity: 0.3;
      margin-bottom: 16px;
    }

    h3 {
      color: #1a237e;
      font-weight: 700;
      font-size: 22px;
      margin: 16px 0 8px 0;
    }

    p {
      color: #666;
      font-size: 14px;
    }
  }

  // DATA TABLE
  ::v-deep .v-data-table {
    background: white !important;
    border-radius: 12px;
    overflow: hidden;
    animation: fadeInUp 0.6s ease-out 0.2s both;
    box-shadow: 0 8px 24px rgba(0, 26, 77, 0.1) !important;

    .v-data-table__wrapper {
      border-radius: 12px;

      table {
        thead tr {
          background: $gradient-main !important;
          animation: slideDown 0.6s ease-out;

          th {
            color: white !important;
            font-weight: 800 !important;
            font-size: 14px !important;
            padding: 16px 12px !important;
            border: none !important;
            letter-spacing: 0.3px;
            text-transform: uppercase;
          }
        }

        tbody tr {
          transition: all 0.3s ease !important;
          border-bottom: 1px solid #e8ecf1 !important;

          &:nth-child(odd) {
            background-color: #f9fafb;
          }

          &:hover {
            background: linear-gradient(
              90deg,
              #e3f2fd 0%,
              #f3e5f5 100%
            ) !important;
            transform: scale(1.001);
            box-shadow: inset 0 2px 8px rgba(25, 118, 210, 0.1);
          }

          td {
            padding: 14px 12px !important;
            font-size: 13px !important;
            color: #333;
            font-weight: 500;
          }
        }
      }
    }

    .v-data-table__pagination {
      background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
    }
  }

  // STATUS CHIP
  .status-chip {
    font-weight: 700 !important;
    border-radius: 20px !important;
    padding: 6px 14px !important;
    font-size: 12px !important;
    letter-spacing: 0.3px;
    animation: pulse 2s infinite;
  }

  // PROFILE IMAGE
  .profile-img-container {
    display: inline-block;
    border-radius: 10px;
    overflow: hidden;
    border: 3px solid #e3f2fd;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
    animation: fadeInUp 0.6s ease-out;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.08);
      box-shadow: 0 8px 20px rgba(25, 118, 210, 0.3);
      border-color: #1976d2;
    }
  }

  .profile-img {
    width: 80px;
    height: 80px;
    object-fit: cover;
    display: block;
  }

  // UTILITY CLASSES
  .mb-6 {
    margin-bottom: 24px;
  }

  .pa-8 {
    padding: 32px;
  }

  .d-flex {
    display: flex;
  }

  .justify-end {
    justify-content: flex-end;
  }

  .gap-2 {
    gap: 12px;
  }

  .overflow-hidden {
    overflow: hidden;
  }

  .white--text {
    color: white;
  }
  .premium-btn-gradient {
    background: linear-gradient(135deg, #f8c51e, #705509) !important;
    color: white !important;
  }

  .premium-btn-gradient:hover {
    background: linear-gradient(135deg, #f8c51e, #705509);
  }
}
</style>
 